import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS}  from '../utils/log';

export const MODULE_NAME = 'PROCESSING_STATS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
};

const UNLOAD = namespaced('UNLOAD');
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const LOAD_DETAILS = namespaced('LOAD_DETAILS');
const LOAD_DETAILS_OK = namespaced('LOAD_DETAILS_OK');
const LOAD_DETAILS_FAIL = namespaced('LOAD_DETAILS_FAIL');

const HIDE_FURTHER_NOTIFICATION = namespaced('HIDE_FURTHER_NOTIFICATION');
const RESET_HIDE_FURTHER_NOTIFICATION = namespaced('RESET_HIDE_FURTHER_NOTIFICATION');

export const ACTION_TYPES = {
  UNLOAD,
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  LOAD_DETAILS,
  LOAD_DETAILS_OK,
  LOAD_DETAILS_FAIL,
  HIDE_FURTHER_NOTIFICATION: HIDE_FURTHER_NOTIFICATION,
  RESET_HIDE_FURTHER_NOTIFICATION
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false, hideFurtherNotification: false}, action={}) => {
    log.debug('updateSubStateFromAction: ', action, state );
    const getNewState = (action, state) => {
        switch (action.type) {
        case UNLOAD:
            return  Object.assign({}, state, {data: undefined, error: null});
        case LOAD:
            return  Object.assign({}, state, {loading: true, error: null});
        case LOAD_OK:
            return Object.assign({}, state, {data: action.response, loading: false, error: null});
        case LOAD_FAIL:
            return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
        case LOAD_DETAILS:
            return  Object.assign({}, state, {loading: true, error: null});
        case LOAD_DETAILS_OK:
            return Object.assign({}, state, {processingStatsDetails: action.response, loading: false, error: null});
        case LOAD_DETAILS_FAIL:
            return Object.assign({}, state, {processingStatsDetails: undefined, loading: false, error: action.error});
        case HIDE_FURTHER_NOTIFICATION:
            return Object.assign({}, state, {hideFurtherNotification: true});
        case RESET_HIDE_FURTHER_NOTIFICATION:
            return Object.assign({}, state, {hideFurtherNotification: false});
        default:
            return state;
        }
    };
    const newState = getNewState(action, state);
    log.debug('updateSubStateFromAction:  newState', newState );
    return newState;
};


export const API = {
    doUnload: () => {
      return (dispatch) => {
        log.debug('doUnload()' );
        dispatch({type: UNLOAD});
      };
    },

    doHideFurtherNotification: () => {
        return (dispatch) => {
            log.debug('doHideFurtherNotification()' );
            dispatch({type: HIDE_FURTHER_NOTIFICATION});
        };
    },

    doResetHideFurtherNotification: (callback) => {
        return (dispatch) => {
            log.debug('doResetHideFurtherNotification()' );
            dispatch({type: RESET_HIDE_FURTHER_NOTIFICATION});
            if(typeof callback === 'function') {
              callback();
            }
        };
    },
  
    doGetProcessingStats: () => {
      return (dispatch) => {
        log.debug('doGetProcessingStats()' );
        dispatch({type: LOAD});
        return CLIENT.getProcessingStats()
          .then((response) => {
            log.debug('doGetProcessingStats(): response: ', response);
            dispatch({type: LOAD_OK, response: response});
          })
          .catch((error) => {
            log.debug('doGetProcessingStats(): error: ', error);
            dispatch({type: LOAD_FAIL, error: error});
          });
      };
    },

    doGetProcessingStatsDetails: (paginationOptions={}) => {
      return (dispatch) => {
        log.debug('doGetProcessingStatsDetails()' );
        dispatch({type: LOAD_DETAILS});
        return CLIENT.getProcessingStats({showOnHoldInvoiceNumbers: true,  ...paginationOptions})
          .then((response) => {
            log.debug('doGetProcessingStatsDetails(): response: ', response);
            dispatch({type: LOAD_DETAILS_OK, response: response});
          })
          .catch((error) => {
            log.debug('doGetProcessingStatsDetails(): error: ', error);
            dispatch({type: LOAD_DETAILS_FAIL, error: error});
          });
      };
    }
}

export default API;
